import cn from 'classnames'
import { createRef, useState } from 'react'
import ValidatorWrapper, { rules, ValidatorField } from '@coxy/react-validator'

import ButtonOrange from 'components/ui/button/_color/_orange'
import { sendMessage } from 'store/fetchers/utils'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

export default function ContactUs() {
  const { t } = useTranslation()
  
  const validator = createRef<any>()
  const [messageText, setMessageText] = useState('')
  const [isRequested, setIsRequested] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [emailValue, setEmailValue] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [descriptionValue, setDescriptionValue] = useState('contact_us_message')

  const handleSendMessage = async (message: string, email: string): Promise<boolean> => {
    return await sendMessage({
      message: message,
      email: email,
    })
  }

  async function handleSubmit(): Promise<void> {
    setSubmitted(true)

    const { isValid } = validator.current.validate()
    if (!isValid) return
    if (isLoading) return

    setIsRequested(false)
    setSubmitted(false)
    setIsLoading(true)

    const result = await handleSendMessage(descriptionValue, emailValue)

    if (result) {
      setMessageText(t('message_sent'))
    } else {
      setMessageText(t('request_error'))
    }

    setIsLoading(false)
    setIsRequested(true)
  }

  const handleChangeEmail = (e: string): void => {
    setEmailValue(e)
    setSubmitted(false)
    setIsRequested(false)
  }

  const handleChangeDescription = (e: string): void => {
    setDescriptionValue(e)
    setIsRequested(false)
  }

  return (
    <div className={cn('container', styles.container)}>
      <div className={styles.title}>{t('contact_us')}</div>
      <div className={styles.inputBlocks}>
        <ValidatorWrapper ref={validator}>
          <label>{t('description')}</label>
          <textarea
            id="contactForm"
            className={styles.textArea}
            value={t(descriptionValue)}
            onChange={(e) => handleChangeDescription(e.target.value)}
          />
          <label>{t('email')}</label>
          <div className={styles.inputWrapper}>
            <ValidatorField value={emailValue} rules={rules.email}>
              {({ isValid, message }) => (
                <>
                  <input value={emailValue} onChange={(e) => handleChangeEmail(e.target.value)} />
                  {!isValid && <span className={cn(styles.hidden, { [styles.incorrect]: submitted })}>
                      {message === 'Email is invalid' ? t('email_invalid') :
                        message === 'Email is required' ? t('email_required') : message}
                    </span>}
                </>
              )}
            </ValidatorField>
            <ButtonOrange isLoading={isLoading} onClick={handleSubmit}>{t('send_action')}</ButtonOrange>
            <span className={cn(styles.messageSent, { [styles.hidden]: !isRequested })}>{messageText}</span>
          </div>
        </ValidatorWrapper>
      </div>
    </div>
  )
}
